import React from 'react'
import {
  Card,
  Form,
  Button,
  Input,
  Select,
  DatePicker,
  Upload,
  message,
  Cascader, Divider, Row, Col, Modal, Space,
} from 'antd'
import './index.less'
import PlusCircleOutlined from "@ant-design/icons/lib/icons/PlusCircleOutlined";
import MinusCircleOutlined from "@ant-design/icons/lib/icons/MinusCircleOutlined";
import TextArea from "antd/lib/input/TextArea";
import {
  API_HOST_WEBSOCKET,
  API_IMG_UPLOAD
} from "../../../constants";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import ImgCrop from "antd-img-crop";
import {withRouter} from "react-router-dom";
import {NavLink} from "react-router-dom";
import {getCategorieList, getMaterialList, getProductInfo, getProductSave} from "../../../constants/api";
import {removeToken} from "../../../utils/cookie";

import {COMMON_ROUTER} from "../../../constants";

const FormItem = Form.Item;

class EditGood extends React.Component {


  constructor(props) {
    super(props)
    this.formRef = React.createRef()

    this.connectWebSocket();
  }

  componentWillMount() {
    this.setState({
      id: this.props.location.state.id,
      templateId: this.props.location.state.templateId,
      shopId: this.props.location.state.shopId,
      platformType: this.props.location.state.platformType
    })
  }

  state = {
    templateId: '',
    shopId: '',
    saleTime: '',//售卖时间
    isSaleHot: '', //是否热销
    isSingle: '', //是否单点
    isFull: '', //是否次日置满
    timeInterval: '', //
    previewVisible: false,
    previewImage: '',
    fileList: [],

    attributes: [],//售卖属性
    description: '', //商品描述
    imageHash: '', //商品哈希
    labels: [], //商品标签
    materials: [], //商品原料
    minPurchaseQuantity: 1, //最小购买量
    productId: '',//商品id
    productName: '',//商品名称
    specs: '',//售卖规格
    unit: '',//商品单位
    xmCategoryId: '', //商品分类
    showImg: true, //图片
    materialsFields: [],
    platformType: '', //平台类型

    mmaterialLength: 0,
    materialIds: [], //获取到的原料默认值id
    materialNames: [],//获取到的原料默认值
    materialIds2: [], //获取到的原料默认值id
    materialNames2: [],//获取到的原料默认值
    materialIds3: [], //获取到的原料默认值id
    materialNames3: [],//获取到的原料默认值
    materialIds4: [], //获取到的原料默认值id
    materialNames4: [],//获取到的原料默认值
    materialIds5: [], //获取到的原料默认值id
    materialNames5: [],//获取到的原料默认值

    loading: false,
  }

  componentDidMount() {
    this.getGoodsMaterial()
    this.getGoodsDetail();
    this.getGoodsClassify();

  }

  connectWebSocket() {
    const _this = this;
    let websocket, lockReconnect = false;
    this.createWebSocket = (url) => {
      websocket = new WebSocket(url);
      websocket.onopen = function () {
        heartCheck.reset().start();
      }
      websocket.onerror = function () {
        reconnect(url);
      };
      websocket.onclose = function (e) {
        console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
      }
      websocket.onmessage = function (event) {
        console.log(event.data)
        if (event.data === '连接成功') {
          lockReconnect = true;
          _this.setState({
            loading: false
          })
        } else if (event.data == 'HeartBeat') {

        } else {
          let data = JSON.parse(event.data)
          lockReconnect = true;
          //event 为服务端传输的消息，在这里可以处理
          if (data.dataHandleStatus === 1) {
            message.success("修改成功", 1, () => {
              this.props.history.push(COMMON_ROUTER + '/goods')
            })
            _this.setState({
              loading: false
            })
          }
        }

      }
    }
    let reconnect = (url) => {
      if (lockReconnect) return;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
        this.createWebSocket(url);
        lockReconnect = false;
      }, 4000);
    }
    let heartCheck = {
      timeout: 60000, //60秒
      timeoutObj: null,
      reset: function () {
        clearInterval(this.timeoutObj);
        return this;
      },
      start: function () {
        this.timeoutObj = setInterval(function () {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          //onmessage拿到返回的心跳就说明连接正常
          websocket.send("HeartBeat");
        }, this.timeout)
      }
    }
    //关闭连接
    this.closeWebSocket = () => {
      websocket && websocket.close();
    }
  }

  /**
   * @Description 获取商品分类
   * @Author Jiang
   * @Date 2020/7/26 11:34
   */
  getGoodsClassify = () => {
    getCategorieList({
      pageIndex: 0,
      pageSize: 100,
      sortName: "",
      sortType: "",
      shopId: this.state.shopId,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let classify = data.data.records;
          this.setState({
            goodsClassify: classify
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_GOODS_CLASSIFY, {
    //   pageIndex: 0,
    //   pageSize: 100,
    //   sortName: "",
    //   sortType: "descending",
    //   shopId: this.state.shopId,
    //   templateId: this.state.templateId
    // }).then(res => {
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       let classify = data.data.records;
    //       this.setState({
    //         goodsClassify: classify
    //       })
    //     }
    //   }
    // })
  }

  /**
   * @Description: 获取商品原料
   * @Author Jiang
   * @Date 2020/7/26 11:55
   */
  getGoodsMaterial = (parentId = 0, targetOption = []) => {
    getMaterialList({
      parentId: parentId,
      platformType:this.state.platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let material = data.data
          if (parentId === 0) {
            material.map((item, index) => {
              item['isLeaf'] = false
            })
            this.setState({
              material: material
            })
          }
          if (parentId !== 0 && targetOption.lev === 1) {
            material.map((item, index) => {
              item['isLeaf'] = false
            })
            targetOption.children = material
            this.setState({
              material: [...this.state.material]
            })
          }
          if (parentId !== 0 && targetOption.lev === 2) {
            material.map((item, index) => {
              item['isLeaf'] = true
            })
            targetOption.children = material
            this.setState({
              material: [...this.state.material]
            })
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


    // axios.post(API_GOODS_MATERIAl, {
    //   parentId: parentId,
    //   platformType:this.state.platformType
    // }).then(res => {
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       let material = data.data
    //       if (parentId === 0) {
    //         material.map((item, index) => {
    //           item['isLeaf'] = false
    //         })
    //         this.setState({
    //           material: material
    //         })
    //       }
    //       if (parentId !== 0 && targetOption.lev === 1) {
    //         material.map((item, index) => {
    //           item['isLeaf'] = false
    //         })
    //         targetOption.children = material
    //         this.setState({
    //           material: [...this.state.material]
    //         })
    //       }
    //       if (parentId !== 0 && targetOption.lev === 2) {
    //         material.map((item, index) => {
    //           item['isLeaf'] = true
    //         })
    //         targetOption.children = material
    //         this.setState({
    //           material: [...this.state.material]
    //         })
    //       }
    //     }
    //   }
    // })
  }

  /**
   * @Description: 动态加载原料
   * @Author Jiang
   * @Date 2020/7/26 14:06
   */
  onMaterialChange = (value, selectedOptions) => {
    console.log(value)
    console.log(selectedOptions)
    this.setState({
      materialIds: value,
    })
    if (selectedOptions.length === 3) {
      this.setState({
        materialNames: [selectedOptions[0].materialName, selectedOptions[1].materialName, selectedOptions[2].materialName]
      })
    }
  }
  onMaterialChange2 = (value, selectedOptions) => {
    console.log(value)
    console.log(selectedOptions)
    this.setState({
      materialIds2: value,
    })
    if (selectedOptions.length === 3) {
      this.setState({
        materialNames2: [selectedOptions[0].materialName, selectedOptions[1].materialName, selectedOptions[2].materialName]
      })
    }
  }
  onMaterialChange3 = (value, selectedOptions) => {
    console.log(value)
    console.log(selectedOptions)
    this.setState({
      materialIds3: value,
    })
    if (selectedOptions.length === 3) {
      this.setState({
        materialNames3: [selectedOptions[0].materialName, selectedOptions[1].materialName, selectedOptions[2].materialName]
      })
    }
  }
  onMaterialChange4 = (value, selectedOptions) => {
    console.log(value)
    console.log(selectedOptions)
    this.setState({
      materialIds4: value,
    })
    if (selectedOptions.length === 3) {
      this.setState({
        materialNames4: [selectedOptions[0].materialName, selectedOptions[1].materialName, selectedOptions[2].materialName]
      })
    }
  }
  onMaterialChange5 = (value, selectedOptions) => {
    console.log(value)
    console.log(selectedOptions)
    this.setState({
      materialIds5: value,
    })
    if (selectedOptions.length === 3) {
      this.setState({
        materialNames5: [selectedOptions[0].materialName, selectedOptions[1].materialName, selectedOptions[2].materialName]
      })
    }
  }


  //base64图片文件
  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  //图片预览取消函数
  handleCancel = () => this.setState({previewVisible: false});

  //图片预览弹窗函数
  handlePreview = async file => {
    // console.log(file)
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };
  beforeUpload = (file) => {
    // console.log(file)
    // 控制上传图片格式
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

    if (!isJpgOrPng) {
      message.error('您只能上传JPG/PNG 文件!');
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      message.error('图片大小必须小于5MB!');
      return false;
    }
    return isJpgOrPng && isLt2M;
  }

  //上传文件改变时的状态，详情可以参考antd的Upload组件API参数
  onImgChange = ({fileList, file, event}) => {
    this.setState({
      fileList: fileList,
      showImg: false,
    })

  };


  /**
   * @Description: 动态获取原料子级数据
   * @Author Jiang
   * @Date 2020/7/26 14:08
   */
  loadData = (material, selectedOptions) => {
    // console.log(material)
    // console.log(selectedOptions)
    //得到所选的select
    const targetOption = selectedOptions[selectedOptions.length - 1];
    this.getGoodsMaterial(targetOption.id, targetOption)
  };


  /**
   * @Description: 显示更多
   * @Author Jiang
   * @Date 2020/7/26 17:04
   */
  showMore = () => {

  }

  onChangeTimeinterval = e => {
    console.log('radio checked', e.target.value);
    this.setState({
      timeInterval: e.target.value,
    });
  };

  onChangeWeek(checkedValues) {
    console.log('checked = ', checkedValues);
  }


  onChange = e => {
    this.setState({
      saleTime: e.target.value,
    });
  };
  onChangeHot = (e) => {
    this.setState({
      isSaleHot: e.target.value,
    });
  }
  onChangeSingle = (e) => {
    this.setState({
      isSingle: e.target.value,
    });
  }

  onChangeFull = (e) => {
    this.setState({
        isFull: e.target.value
      }
    )
  }
  /*提交数据*/
  onFinish = (values) => {
    console.log(values)
//处理规格
    let specList = values.specification
    specList.map((spec, index) => {
      spec['activityLevel'] = 0
      spec['barCode'] = ""
      spec['onShelf'] = 1
      spec['pid'] = 0
      spec['specId'] = 0
      spec['stockStatus'] = 0
      spec['weight'] = 0
    })

    //处理原料
    let materialList = values.materialList
    let materialListTemp = [];
    // materialList.map((material, index) => {
    //   let m = material.material;
    //   let end = m[m.length - 1];
    //   let obj = {id: end};
    //   materialListTemp.push(obj)
    // })

    const {
      materialIds, materialNames,
      materialIds2, materialNames2,
      materialIds3, materialNames3,
      materialIds4, materialNames4,
      materialIds5, materialNames5
    } = this.state
    if (materialIds2.length === 0 && materialIds3.length === 0 && materialIds4.length === 0 && materialIds5.length === 0) {
      materialListTemp = [{id: materialIds[2], name: materialNames[2]}]
    } else if (materialIds2.length !== 0 && materialIds3.length === 0 && materialIds4.length === 0 && materialIds5.length === 0) {
      materialListTemp = [{id: materialIds[2], name: materialNames[2]},
        {id: materialIds2[2], name: materialNames2[2]}]
    } else if (materialIds2.length !== 0 && materialIds3.length !== 0 && materialIds4.length === 0 && materialIds5.length === 0) {
      materialListTemp = [{id: materialIds[2], name: materialNames[2]},
        {id: materialIds2[2], name: materialNames2[2]},
        {id: materialIds3[2], name: materialNames3[2]}]
    } else if (materialIds2.length !== 0 && materialIds3.length !== 0 && materialIds4.length !== 0 && materialIds5.length === 0) {
      materialListTemp = [{id: materialIds[2], name: materialNames[2]},
        {id: materialIds2[2], name: materialNames2[2]},
        {id: materialIds3[2], name: materialNames3[2]},
        {id: materialIds4[2], name: materialNames4[2]}]
    } else if (materialIds2.length !== 0 && materialIds3.length !== 0 && materialIds4.length !== 0 && materialIds5.length !== 0) {
      materialListTemp = [{id: materialIds[2], name: materialNames[2]},
        {id: materialIds2[2], name: materialNames2[2]},
        {id: materialIds3[2], name: materialNames3[2]},
        {id: materialIds4[2], name: materialNames4[2]},
        {id: materialIds5[2], name: materialNames5[2]}]
    }

    //商品描述
    let description = values.description
    //商品名称
    let productName = values.productName
    //店铺Id
    let shopId = 0
    //商品最小购买量
    let minPurchaseQuantity = values.minPurchaseQuantity
    //商品单位
    let unit = values.unit
    //商品分类
    let xmCategoryId = values.xmCategoryId
    //商品图片
    let fileList = this.state.fileList
    var imageHash = ''
    var imageUrl = ''
    console.log(this.state.fileList)
    if (this.state.showImg) {
      imageHash = this.state.imageHash,
        imageUrl = this.state.imageUrl
    } else {
      if (fileList[0]) {
        let file = fileList[0];
        if (file.response) {
          let res = file.response;
          if (res.code === 0) {

            let img = res.data
            imageHash = img.imageHash
            imageUrl = img.imageUrl
          } else {
            message.error('图片格式有误', 0.5, () => {
              return;
            })
          }
        }
      }
    }


    //商品标签
    let labels = values.labels;
    let isFeatured = 0;
    let isGum = 0;
    let isNew = 0;
    let isSpicy = 0;
    labels.map((label, index) => {
      switch (label) {
        case "0":
          isFeatured = 1
          break;
        case "1":
          isNew = 1;
          break;
        case "2":
          isSpicy = 1;
          break;
        default:
          break
      }
    })
    labels = {};
    labels['isFeatured'] = isFeatured;
    labels['isNew'] = isNew;
    labels['isSpicy'] = isSpicy;
    labels['isGum'] = isGum;

    console.log('222222222222')
    //售卖属性
    let attributes = values.attributes;

    let attributeTemp = []
    attributes.map((item, index) => {
      let details = [];
      let name = item.attributeName;
      if (item.detail_one) {
        details.push(item.detail_one)
      }
      if (item.detail_two) {
        details.push(item.detail_two)
      }
      if (item.detail_three) {
        details.push(item.detail_three)
      }
      if (item.detail_four) {
        details.push(item.detail_four)
      }
      item = {};
      item['attributeName'] = name;
      item['details'] = details
      attributeTemp.push(item)
    })
    console.log(attributeTemp)
    getProductSave({
      description: description,
      imageHash: imageHash,
      imageUrl: imageUrl,
      labels: labels,
      attribute: attributeTemp,
      materialList: materialListTemp,
      minPurchaseQuantity: minPurchaseQuantity,
      productName: productName,
      productId: this.state.id,
      shopId: this.state.shopId,
      specList: specList,
      templateId: this.state.templateId,
      unit: unit,
      xmCategoryId: xmCategoryId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          if (data.data.dataHandleStatus === 0) {
            //建立websocket
            this.useWebSocketSync(data.data.messageKey)
          } else {
            message.success("修改成功", 1, () => {
              this.props.history.push(COMMON_ROUTER + '/goods')
            })
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_GOODS_SAVE, {
    //   description: description,
    //   imageHash: imageHash,
    //   imageUrl: imageUrl,
    //   labels: labels,
    //   attribute: attributeTemp,
    //   materialList: materialListTemp,
    //   minPurchaseQuantity: minPurchaseQuantity,
    //   productName: productName,
    //   productId: this.state.id,
    //   shopId: this.state.shopId,
    //   specList: specList,
    //   templateId: this.state.templateId,
    //   unit: unit,
    //   xmCategoryId: xmCategoryId
    // }).then(res => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       if (data.data.dataHandleStatus === 0) {
    //         //建立websocket
    //         this.useWebSocketSync(data.data.messageKey)
    //       } else {
    //         message.success("修改成功", 1, () => {
    //           this.props.history.push(COMMON_ROUTER + '/goods')
    //         })
    //       }
    //
    //       // this.props.history.push({
    //       //   pathname: COMMON_ROUTER + '/goods',
    //       //   state:{
    //       //     templateId: this.state.templateId,
    //       //     shopId: this.state.shopId
    //       //   }
    //       // })
    //     } else {
    //       message.error("修改失败")
    //     }
    //   } else {
    //     message.error('修改失败')
    //   }
    // }).catch(error => {
    //   message.error(error.message)
    // })
  }

  useWebSocketSync(key) {
    this.setState({loading: true})
    let url = "wss://" + API_HOST_WEBSOCKET + "/websocket/message/" + key;//服务端连接的url
    this.createWebSocket(url)
    //在组件卸载的时候，关闭连接
    return () => {
      this.closeWebSocket();
    }
  }

  /**
   * @Description: 获取商品详情
   * @Author Jiang
   * @Date 2020/7/29 16:49
   */
  getGoodsDetail = () => {
    getProductInfo({
      id: this.state.id,
      shopId: this.state.shopId,
      templateId: this.state.templateId,
      platformType:this.state.platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let goods = data.data
          console.log('_____________________________')
          console.log(goods)
          let attributes = goods.attributes
          let description = goods.description
          let imageHash = goods.imageHash
          let imageUrl = goods.imageUrl
          let labels = goods.labels
          let materials = goods.materialList
          let minPurchaseQuantity = goods.minPurchaseQuantity
          let productId = goods.productId
          let productName = goods.productName
          let specs = goods.specList
          let unit = goods.unit
          let xmCategoryId = goods.xmCategoryId

          //处理labels
          let labelTemp = [];
          labels = JSON.parse(labels)
          // console.log(labels)
          if (labels) {
            if (labels.isFeatured === 1) {
              labelTemp.push('0')
            }
            if (labels.isNew === 1) {
              labelTemp.push('1')
            }
            if (labels.isSpicy === 1) {
              labelTemp.push('2')
            }
          }


          //处理属性
          attributes = JSON.parse(attributes)
          // console.log(attributes)

          let attributesTemp = [];
          if (attributes) {
            attributes.map((attribute, index) => {
              let attributeTemp = {};
              // console.log(attribute)
              let attributeName = attribute.attributeName
              attributeTemp['attributeName'] = attributeName
              let details = attribute.details
              details.map((detail, i) => {
                if (i === 0) {
                  let detail_one = detail
                  attributeTemp['detail_one'] = detail_one
                }
                if (i === 1) {
                  let detail_two = detail
                  attributeTemp['detail_two'] = detail_two
                }
                if (i === 2) {
                  let detail_three = detail
                  attributeTemp['detail_three'] = detail_three
                }
                if (i === 3) {
                  let detail_four = detail
                  attributeTemp['detail_four'] = detail_four
                }
              })
              attributesTemp.push(attributeTemp)
            })
          }

          // specs = JSON.parse(specs)
//处理原料

          if (materials && materials.length === 1) {
            let temp = materials[0]
            this.setState({
              materialLength: materials.length,
              materialIds: [temp[0].id, temp[1].id, temp[2].id],
              materialNames: [temp[0].materialName, temp[1].materialName, temp[2].materialName]
            })
          } else if (materials && materials.length === 2) {
            let temp = materials[0]
            let temp2 = materials[1]
            this.setState({
              materialLength: materials.length,
              materialIds: [temp[0].id, temp[1].id, temp[2].id],
              materialNames: [temp[0].materialName, temp[1].materialName, temp[2].materialName],
              materialIds2: [temp2[0].id, temp2[1].id, temp2[2].id],
              materialNames2: [temp2[0].materialName, temp2[1].materialName, temp2[2].materialName]
            })
          } else if (materials && materials.length === 3) {
            let temp = materials[0]
            let temp2 = materials[1]
            let temp3 = materials[2]
            this.setState({
              materialLength: materials.length,
              materialIds: [temp[0].id, temp[1].id, temp[2].id],
              materialNames: [temp[0].materialName, temp[1].materialName, temp[2].materialName],
              materialIds2: [temp2[0].id, temp2[1].id, temp2[2].id],
              materialNames2: [temp2[0].materialName, temp2[1].materialName, temp2[2].materialName],
              materialIds3: [temp3[0].id, temp3[1].id, temp3[2].id],
              materialNames3: [temp3[0].materialName, temp3[1].materialName, temp3[2].materialName]
            })
          }

          //将原料所有参数获取获取
          materials &&  materials.map((material, index) => {
            // console.log(material)
            this.loadData(material.id, material)
          })
          let materialsFields = [];
          materials &&   materials.map((item, index) => {
            let materialField = {};
            materialField['key'] = index
            materialField['name'] = index
            materialField['fieldKey'] = index
            materialField['material'] = item
            materialsFields.push(materialField)
          })
//处理图片
          this.setState({
            imageUrl: imageUrl,
            imageHash: imageHash,
            materials: materials,
            materialsFields: materialsFields
          })
          // console.log(specs)
          this.formRef.current.setFieldsValue({
            attributes: attributesTemp,
            description: description,
            imageHash: imageHash,
            labels: labelTemp,
            materialList: materials,
            minPurchaseQuantity: minPurchaseQuantity,
            productId: productId,
            productName: productName,
            specification: specs,
            unit: unit,
            xmCategoryId: xmCategoryId
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })


//     axios.post(API_GOODS_DETAIL, {
//       id: this.state.id,
//       shopId: this.state.shopId,
//       templateId: this.state.templateId,
//       platformType:this.state.platformType
//     }).then(res => {
//       if (res.status === 200) {
//         let data = res.data
//         if (data.code === 0) {
//           let goods = data.data
//           console.log('_____________________________')
//           console.log(goods)
//           let attributes = goods.attributes
//           let description = goods.description
//           let imageHash = goods.imageHash
//           let imageUrl = goods.imageUrl
//           let labels = goods.labels
//           let materials = goods.materialList
//           let minPurchaseQuantity = goods.minPurchaseQuantity
//           let productId = goods.productId
//           let productName = goods.productName
//           let specs = goods.specList
//           let unit = goods.unit
//           let xmCategoryId = goods.xmCategoryId
//
//           //处理labels
//           let labelTemp = [];
//           labels = JSON.parse(labels)
//           // console.log(labels)
//           if (labels) {
//             if (labels.isFeatured === 1) {
//               labelTemp.push('0')
//             }
//             if (labels.isNew === 1) {
//               labelTemp.push('1')
//             }
//             if (labels.isSpicy === 1) {
//               labelTemp.push('2')
//             }
//           }
//
//
//           //处理属性
//           attributes = JSON.parse(attributes)
//           // console.log(attributes)
//
//           let attributesTemp = [];
//           if (attributes) {
//             attributes.map((attribute, index) => {
//               let attributeTemp = {};
//               // console.log(attribute)
//               let attributeName = attribute.attributeName
//               attributeTemp['attributeName'] = attributeName
//               let details = attribute.details
//               details.map((detail, i) => {
//                 if (i === 0) {
//                   let detail_one = detail
//                   attributeTemp['detail_one'] = detail_one
//                 }
//                 if (i === 1) {
//                   let detail_two = detail
//                   attributeTemp['detail_two'] = detail_two
//                 }
//                 if (i === 2) {
//                   let detail_three = detail
//                   attributeTemp['detail_three'] = detail_three
//                 }
//                 if (i === 3) {
//                   let detail_four = detail
//                   attributeTemp['detail_four'] = detail_four
//                 }
//               })
//               attributesTemp.push(attributeTemp)
//             })
//           }
//
//           // specs = JSON.parse(specs)
// //处理原料
//
//           if (materials && materials.length === 1) {
//             let temp = materials[0]
//             this.setState({
//               materialLength: materials.length,
//               materialIds: [temp[0].id, temp[1].id, temp[2].id],
//               materialNames: [temp[0].materialName, temp[1].materialName, temp[2].materialName]
//             })
//           } else if (materials && materials.length === 2) {
//             let temp = materials[0]
//             let temp2 = materials[1]
//             this.setState({
//               materialLength: materials.length,
//               materialIds: [temp[0].id, temp[1].id, temp[2].id],
//               materialNames: [temp[0].materialName, temp[1].materialName, temp[2].materialName],
//               materialIds2: [temp2[0].id, temp2[1].id, temp2[2].id],
//               materialNames2: [temp2[0].materialName, temp2[1].materialName, temp2[2].materialName]
//             })
//           } else if (materials && materials.length === 3) {
//             let temp = materials[0]
//             let temp2 = materials[1]
//             let temp3 = materials[2]
//             this.setState({
//               materialLength: materials.length,
//               materialIds: [temp[0].id, temp[1].id, temp[2].id],
//               materialNames: [temp[0].materialName, temp[1].materialName, temp[2].materialName],
//               materialIds2: [temp2[0].id, temp2[1].id, temp2[2].id],
//               materialNames2: [temp2[0].materialName, temp2[1].materialName, temp2[2].materialName],
//               materialIds3: [temp3[0].id, temp3[1].id, temp3[2].id],
//               materialNames3: [temp3[0].materialName, temp3[1].materialName, temp3[2].materialName]
//             })
//           }
//
//           //将原料所有参数获取获取
//         materials &&  materials.map((material, index) => {
//             // console.log(material)
//             this.loadData(material.id, material)
//           })
//           let materialsFields = [];
//           materials &&   materials.map((item, index) => {
//             let materialField = {};
//             materialField['key'] = index
//             materialField['name'] = index
//             materialField['fieldKey'] = index
//             materialField['material'] = item
//             materialsFields.push(materialField)
//           })
// //处理图片
//           this.setState({
//             imageUrl: imageUrl,
//             imageHash: imageHash,
//             materials: materials,
//             materialsFields: materialsFields
//           })
//           // console.log(specs)
//           this.formRef.current.setFieldsValue({
//             attributes: attributesTemp,
//             description: description,
//             imageHash: imageHash,
//             labels: labelTemp,
//             materialList: materials,
//             minPurchaseQuantity: minPurchaseQuantity,
//             productId: productId,
//             productName: productName,
//             specification: specs,
//             unit: unit,
//             xmCategoryId: xmCategoryId
//           })
//         }
//       }
//     })
  }
  getAllOptions = (id) => {

  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: 24,
        sm: 4
      },
      wrapperCol: {
        xs: 24,
        sm: 12
      }
    }
    const offsetLayout = {
      wrapperCol: {
        xs: 24,
        sm: {
          span: 12,
          offset: 4
        }
      }
    }

    let featureData = [
      {
        title: '招牌菜',
        value: '0',
      },
      {
        title: '新菜',
        value: '1',
      },
      {
        title: '辣',
        value: '2',
      },
    ];

    const {RangePicker} = DatePicker;
    const format = 'HH:mm';
    const dateOptions = ['周一', '周二', '周三', '周四', '周四', '周五', '周六', '周日'];
    let {listSepecification, material, listAttribute, listMaterial, listSaleTime, goodsClassify, previewVisible, previewImage, fileList, loading} = this.state

    //根据官方属性定制化裁剪框大小固定的裁剪组件属性
    const props = {
      width: 800,  //裁剪宽度
      height: 800, //裁剪高度
      resize: false, //裁剪是否可以调整大小
      resizeAndDrag: true, //裁剪是否可以调整大小、可拖动
      modalTitle: "上传图片", //弹窗标题
      modalWidth: 900, //弹窗宽度
    };
    let fetchedFields = [{'name': 0, 'key': 0, 'fieldKey': 0}];
    return (
      <Card style={{width: "100%", margin: '0 auto', overflowY: "auto", height: "100vh", padding: "0 0 40px"}}
            title="编辑商品">
        <Form initialValues={{
          specification: fetchedFields, attribute: fetchedFields,
          materialList: this.state.materials,
          // material_one: this.state.materialNames
          // material_one: ['10026', '10034', '10042']
        }} onFinish={this.onFinish.bind(this)} ref={this.formRef}>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'top'}>
            <Col className={['gutter-row']} offset={6} span={2}>
              <div className='input-title'>基本信息</div>
            </Col>
            <Col className='gutter-row' id='xmCategoryId' span={10}>
              {goodsClassify &&
              <FormItem name='xmCategoryId' rules={[
                {
                  required: true,
                  message: '商品分类不能为空'
                }
              ]} label="商品分类" {...formItemLayout}>
                <Select style={{marginLeft: "20px"}}
                        getPopupContainer={() => document.getElementById('xmCategoryId')}>
                  {goodsClassify && goodsClassify.map((classify, iindex) => {
                    return <Select.Option key={classify.categorieId}
                                          value={classify.categorieId}>{classify.categorieName}</Select.Option>
                  })}
                </Select>
              </FormItem>
              }
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={8} span={10}>
              <FormItem name='productName' label="商品名称"
                        rules={[{required: true, message: '请输入商品名称',}]} {...formItemLayout}>
                <Input style={{marginLeft: "20px"}} placeholder="请输入商品名称"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={8} span={10}>
              <FormItem name='description' label="商品描述" {...formItemLayout}>
                <TextArea style={{marginLeft: "20px"}} placeholder={'请输入商品描述'} rows={4}/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={8} span={10}>

              <FormItem label="商品图片" labelCol={{span: 4}}
                        {...formItemLayout}>
                {this.state.showImg ? <img src={this.state.imageUrl} className='goods-img'/> : null}

                {/*<ImgCrop {...props}>*/}
                  <Upload
                    name="file"
                    action={API_IMG_UPLOAD}
                    data={{platformType: this.state.platformType}}
                    accept="image/*"
                    listType="picture"
                    fileList={fileList}
                    beforeUpload={this.beforeUpload.bind(this)}
                    onPreview={this.handlePreview}
                    onChange={this.onImgChange}
                  >
                    {fileList.length >= 1 ? null : (<div className='img-container'>
                      <div>
                        <PlusOutlined style={{fontSize: "20px"}}/>
                        点击更换
                      </div>
                    </div>)}
                    {/* {通过三木运算符判断文件列表fileList的长度来决定上传图片的数量，达到控制图片数量的功能} */}
                  </Upload>
                {/*</ImgCrop>*/}
                {/* {图片预览弹出框：可以实时查看上传的图片} */}
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel} title='Image-Show'>
                  <img alt="example" style={{width: '100%'}} src={previewImage}/>
                </Modal>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={8} span={10}>
              <FormItem name='minPurchaseQuantity' label="最小购买量" rules={[{required: true}]} {...formItemLayout}>
                <Input style={{marginLeft: "20px"}} placeholder="请输入最小购买数量"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={8} span={10}>
              <FormItem name='unit' rules={[
                {
                  required: true,
                  message: '只能输入中英文，最多2个字',
                }
              ]} label="商品单位" {...formItemLayout}>
                <Input style={{marginLeft: "20px"}} placeholder="请输入商品单位"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
            <Col className='gutter-row' id='labels' offset={8} span={10}>
              {featureData &&
              <FormItem name='labels' label="商品特色" {...formItemLayout}>
                <Select mode='tags' placeholder={'请选择标签，最多可选择3个'} style={{marginLeft: "20px"}}
                        getPopupContainer={() => document.getElementById('labels')}>
                  {featureData && featureData.map((feature, iindex) => {
                    return <Select.Option key={feature.value}
                                          value={feature.value}>{feature.title}</Select.Option>
                  })}
                </Select>
              </FormItem>
              }
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={2} span={20}>
              <Divider/>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="top">
            <Col className={['gutter-row',]} offset={6} span={2}>
              <div className='input-title'>售卖规格</div>
            </Col>
            <Col className='gutter-row' span={12}>
              <Form.List name="specification" initialValue={[]}>
                {(fields, {add, remove}) => {
                  return (
                    <div>
                      {fields.map(field => (
                        <Space key={field.key} style={{display: 'flex', marginBottom: 8}} align="start">
                          <FormItem
                            name={[field.name, 'specName']}
                            rules={[
                              {
                                required: true,
                                message: '只能输入中英文，最多2个字',
                              }
                            ]} label="规格名" layout="vercital">
                            <Input className='input-size'/>
                          </FormItem>
                          <FormItem
                            name={[field.name, 'price']}
                            rules={[
                              {
                                required: true,
                                message: '只能输入中英文，最多2个字',
                              }
                            ]} label="价格" layout="vercital">
                            <Input className='input-size'
                                   addonAfter="元"/>
                          </FormItem>
                          <FormItem name={[field.name, 'packingFee']} rules={[
                            {
                              required: true,
                              message: '只能输入中英文，最多2个字',
                            }
                          ]} label="餐盒费" layout="vercital">

                            <Input className='input-size'
                                   addonAfter="元"/>
                          </FormItem>
                          <Form.Item label={'当前库存/最大库存'} rules={[{required: true}]} layout="vercital">
                            <Input.Group className='inventory'>
                              <Form.Item style={{
                                width: '70px',
                                border: 0,
                                padding: 0,
                                textAlign: 'center'
                              }} name={[field.name, 'stock']} layout="vercital">
                                <Input style={{
                                  border: 0, height: '24px',
                                  lineHeight: "24px",
                                }} placeholder="10000"/>
                              </Form.Item>
                              <div className='incline'>
                                /
                              </div>
                              <Form.Item className="site-input-right"
                                         style={{
                                           width: '70px',
                                           textAlign: 'center',
                                           border: 0
                                         }}
                                         name={[field.name, 'maxStock']}
                              >
                                <Input
                                  style={{
                                    border: 0, height: '24px',
                                    lineHeight: "24px",
                                  }}
                                  placeholder="10000"
                                />
                              </Form.Item>
                            </Input.Group>
                          </Form.Item>
                          {/*<FormItem className='full'>*/}
                          {/*  <div style={{display: "flex", flexDirection: "row"}}>*/}
                          {/*    <Form.Item name={[field.name, 'full']}>*/}
                          {/*      <Checkbox checked={false} onChange={this.onChangeFull.bind(this)}>次日置满</Checkbox>*/}
                          {/*    </Form.Item>*/}
                          {/*    <InfoCircleFilled style={{color: '#535353'}}/>*/}
                          {/*    <div className='more'>*/}
                          {/*      <a onClick={this.showMore.bind(this)}>更多</a>*/}
                          {/*    </div>*/}
                          {/*  </div>*/}
                          {/*</FormItem>*/}
                          {fields.length > 1 ? (
                            <MinusCircleOutlined
                              className="dynamic-delete-button"
                              style={{margin: '0 8px'}}
                              onClick={() => {
                                remove(field.name);
                              }}
                            />
                          ) : null}
                        </Space>
                      ))}

                      <Form.Item>
                        <a
                          type="dashed"
                          onClick={() => {
                            add();
                          }}
                        >
                          <PlusCircleOutlined/> 添加规格最多10个
                        </a>
                      </Form.Item>
                    </div>
                  );
                }}
              </Form.List>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'top'}>
            <Col className={['gutter-row',]} offset={6} span={2}>
              <div className='input-title'>售卖属性</div>
            </Col>
            <Col className='gutter-row' id='materialList' span={10}>
              <Form.List name="attributes">
                {(fields, {add, remove}) => {
                  return (
                    <div>
                      {fields.map((field, index) => (
                        <Space key={field.key} style={{display: 'flex', marginBottom: 8}}>
                          <div key={index.toString()}>
                            <div>
                              同种价格多种口味，如：少糖、半糖等 &nbsp;&nbsp;
                              <a>了解详情</a>
                            </div>
                            <div className='input-specification'>
                              <FormItem
                                name={[field.name, 'attributeName']}  label="属性名称" layout="vercital">
                                <Input className='input-size' placeholder='如:辣度'/>
                              </FormItem>
                              <FormItem rules={[
                                {
                                  required: true,
                                }
                              ]} className='' label="属性细分(至少填2个)" layout="vercital">
                                <Input.Group compact>
                                  <FormItem name={[field.name, 'detail_one']} wrapperCol={{span: 12}} layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                  <FormItem name={[field.name, 'detail_two']} wrapperCol={{span: 12}} layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                  <FormItem name={[field.name, 'detail_three']} wrapperCol={{span: 12}}
                                            layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                  <FormItem name={[field.name, 'detail_four']} wrapperCol={{span: 12}}
                                            layout="vercital">
                                    <Input className='input-size'/>
                                  </FormItem>
                                </Input.Group>
                              </FormItem>
                            </div>
                          </div>
                          {fields.length > 1 ? (
                            <MinusCircleOutlined
                              className="dynamic-delete-button"
                              style={{margin: '0 8px'}}
                              onClick={() => {
                                remove(field.name);
                              }}
                            />
                          ) : null}

                        </Space>
                      ))}

                      <Form.Item>
                        <a
                          type="dashed"
                          onClick={() => {
                            add();
                          }}
                        >
                          <PlusCircleOutlined/> 添加属性最多5个
                        </a>
                      </Form.Item>
                    </div>
                  );
                }}
              </Form.List>
            </Col>
          </Row>

          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'top'}>
            <Col className={['gutter-row',]} offset={6} span={2}>
              <div className='input-title'>商品原料</div>
            </Col>

            {/*  <Col>
              {this.state.materials && this.state.materials.map((item, index) => {
                return <Cascader
                  allowClear
                  fieldNames={{label: 'materialName', value: 'id',}}
                  options={material}
                  loadData={this.loadData.bind(this, item)}
                  onChange={this.onMaterialChange.bind(this)}
                  changeOnSelect
                  getPopupContainer={() => document.getElementById('materialList')}
                  placeholder={'请选择'}
                />
              })}
            </Col>*/}
            <Col className='gutter-row' id='materialList' span={12}>
              {/*<FormItem name='material_one'>*/}
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <Cascader
                  allowClear
                  value={this.state.materialNames}
                  fieldNames={{label: 'materialName', value: 'id',}}
                  options={material}
                  loadData={this.loadData.bind(this, material)}
                  onChange={this.onMaterialChange.bind(this)}
                  changeOnSelect
                  getPopupContainer={() => document.getElementById('materialList')}
                  placeholder={'请选择'}
                />
                <Cascader
                  allowClear
                  style={{marginTop: 10}}
                  value={this.state.materialNames2}
                  fieldNames={{label: 'materialName', value: 'id',}}
                  options={material}
                  loadData={this.loadData.bind(this, material)}
                  onChange={this.onMaterialChange2.bind(this)}
                  changeOnSelect
                  getPopupContainer={() => document.getElementById('materialList')}
                  placeholder={'请选择'}
                />
                <Cascader
                  allowClear
                  style={{marginTop: 10}}
                  value={this.state.materialNames3}
                  fieldNames={{label: 'materialName', value: 'id',}}
                  options={material}
                  loadData={this.loadData.bind(this, material)}
                  onChange={this.onMaterialChange3.bind(this)}
                  changeOnSelect
                  getPopupContainer={() => document.getElementById('materialList')}
                  placeholder={'请选择'}
                />
                <Cascader
                  allowClear
                  style={{marginTop: 10}}
                  value={this.state.materialNames4}
                  fieldNames={{label: 'materialName', value: 'id',}}
                  options={material}
                  loadData={this.loadData.bind(this, material)}
                  onChange={this.onMaterialChange4.bind(this)}
                  changeOnSelect
                  getPopupContainer={() => document.getElementById('materialList')}
                  placeholder={'请选择'}
                />
                <Cascader
                  allowClear
                  style={{marginTop: 10, marginBottom: 10}}
                  value={this.state.materialNames5}
                  fieldNames={{label: 'materialName', value: 'id',}}
                  options={material}
                  loadData={this.loadData.bind(this, material)}
                  onChange={this.onMaterialChange5.bind(this)}
                  changeOnSelect
                  getPopupContainer={() => document.getElementById('materialList')}
                  placeholder={'请选择'}
                />
              </div>

              {/*</FormItem>*/}
            </Col>
            {/*<Col className='gutter-row' id='materialList' span={12}>*/}
            {/*  <Form.List name="materialList">*/}
            {/*    {(fields, {add, remove}) => {*/}
            {/*      return (*/}
            {/*        <div>*/}
            {/*          {fields.map((field, index) => (*/}
            {/*            <Space key={field.key} style={{display: 'flex', marginBottom: 8}} align="start">*/}
            {/*              <FormItem name={[field.name, 'material']} rules={[*/}
            {/*                {*/}
            {/*                  required: true,*/}
            {/*                  message: '商品名称不能为空'*/}
            {/*                }*/}
            {/*              ]}>*/}
            {/*                <Cascader*/}
            {/*                  allowClear*/}
            {/*                  value={this.state.materialNames}*/}
            {/*                  fieldNames={{label: 'materialName', value: 'id',}}*/}
            {/*                  options={material}*/}
            {/*                  loadData={this.loadData.bind(this, field.material)}*/}
            {/*                  onChange={this.onMaterialChange.bind(this)}*/}
            {/*                  changeOnSelect*/}
            {/*                  getPopupContainer={() => document.getElementById('materialList')}*/}
            {/*                  placeholder={'请选择'}*/}
            {/*                />*/}
            {/*              </FormItem>*/}
            {/*              {fields.length > 1 ? (*/}
            {/*                <MinusCircleOutlined*/}
            {/*                  className="dynamic-delete-button"*/}
            {/*                  style={{margin: '0 8px'}}*/}
            {/*                  onClick={() => {*/}
            {/*                    remove(field.name);*/}
            {/*                  }}*/}
            {/*                />*/}
            {/*              ) : null}*/}
            {/*            </Space>*/}
            {/*          ))}*/}

            {/*          <Form.Item>*/}
            {/*            <a*/}
            {/*              type="dashed"*/}
            {/*              onClick={() => {*/}
            {/*                add();*/}
            {/*              }}*/}
            {/*            >*/}
            {/*              <PlusCircleOutlined/> 添加原料最多5个*/}
            {/*            </a>*/}
            {/*          </Form.Item>*/}
            {/*        </div>*/}
            {/*      );*/}
            {/*    }}*/}
            {/*  </Form.List>*/}
            {/*</Col>*/}
          </Row>
          {/*********售卖时间***********/}
          {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="center" align="center">*/}
          {/*  <Col className={['gutter-row',]} offset={6} span={2}>*/}
          {/*    <div className='input-title-size'>售卖时间</div>*/}
          {/*  </Col>*/}
          {/*  <Col className='gutter-row' span={12}>*/}
          {/*    <Form.Item label="售卖时间段">*/}
          {/*      <RadioGroup onChange={this.onChange.bind(this)} value={this.state.saleTime}>*/}
          {/*        <Radio value={1}>全时段售卖</Radio>*/}
          {/*        <Radio value={2}>自定义时间</Radio>*/}
          {/*      </RadioGroup>*/}
          {/*    </Form.Item>*/}
          {/*    {*/}
          {/*      this.state.saleTime == 2 ?*/}
          {/*        <div>*/}
          {/*          <FormItem label='选择时间段'>*/}
          {/*            <RangePicker style={{marginLeft: "10px"}}/>*/}
          {/*            <Checkbox.Group options={dateOptions}*/}
          {/*                            defaultValue={['周一', '周二', '周三', '周四', '周四', '周五', '周六', '周日']}*/}
          {/*                            onChange={this.onChangeWeek.bind(this)}/>*/}
          {/*          </FormItem>*/}
          {/*          <FormItem label='售卖时间段'>*/}
          {/*            <RadioGroup style={{marginLeft: "10px"}}*/}
          {/*                        onChange={this.onChangeTimeinterval.bind(this)}*/}
          {/*                        value={this.state.timeInterval}>*/}
          {/*              <Radio value={1}>全时段售卖</Radio>*/}
          {/*              <Radio value={2}>自定义时间</Radio>*/}
          {/*            </RadioGroup>*/}
          {/*          </FormItem>*/}
          {/*          {*/}
          {/*            this.state.timeInterval == 2 ?*/}
          {/*              <div>*/}
          {/*                {*/}
          {/*                  listSaleTime.map((item, index) => {*/}
          {/*                    return (*/}
          {/*                      <div key={index.toString()}>*/}
          {/*                        <div className='input-specification'>*/}
          {/*                          <div style={{display: "row", width: "100vh"}}>*/}
          {/*                            <TimePicker*/}
          {/*                              defaultValue={moment('00:00', format)}*/}
          {/*                              format={format}/>*/}
          {/*                            <div style={{*/}
          {/*                              fontSize: "12px",*/}
          {/*                              marginLeft: "10px",*/}
          {/*                              marginRight: "10px"*/}
          {/*                            }}>至*/}
          {/*                            </div>*/}
          {/*                            <TimePicker*/}
          {/*                              defaultValue={moment('00:00', format)}*/}
          {/*                              format={format}/>*/}
          {/*                          </div>*/}
          {/*                          {index > 0 ?*/}
          {/*                            <div className='remove'*/}
          {/*                                 onClick={this.removeSaleTime.bind(this, index)}>*/}
          {/*                              <MinusCircleOutlined/>移除*/}
          {/*                            </div> : null*/}
          {/*                          }*/}
          {/*                        </div>*/}
          {/*                      </div>*/}
          {/*                    )*/}
          {/*                  })*/}
          {/*                }*/}
          {/*                {*/}
          {/*                  listSaleTime.length < 3 ?*/}
          {/*                    <a onClick={this.addSaleTime.bind(this)}>*/}
          {/*                      <PlusCircleOutlined/> 添加属性最多3个*/}
          {/*                    </a> : null*/}
          {/*                }*/}
          {/*              </div> : null*/}
          {/*          }*/}
          {/*        </div> : null*/}
          {/*    }*/}
          {/*  </Col>*/}
          {/*</Row>*/}
          {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="center" align="center">*/}
          {/*  <Col className={['gutter-row',]} offset={6} span={2}>*/}
          {/*    <div className='input-title-size'>其他信息</div>*/}
          {/*  </Col>*/}
          {/*  <Col className='gutter-row' span={12}>*/}
          {/*    <Form.Item label="参与热销排行">*/}
          {/*      <RadioGroup onChange={this.onChangeHot.bind(this)} value={this.state.isSaleHot}>*/}
          {/*        <Radio value={1}>是</Radio>*/}
          {/*        <Radio value={2}>否</Radio>*/}
          {/*      </RadioGroup>*/}
          {/*    </Form.Item>*/}
          {/*    <Form.Item label="单点时不配送">*/}
          {/*      <RadioGroup onChange={this.onChangeSingle.bind(this)} value={this.state.isSingle}>*/}
          {/*        <Radio value={1}>是</Radio>*/}
          {/*        <Radio value={2}>否</Radio>*/}
          {/*      </RadioGroup>*/}
          {/*    </Form.Item>*/}
          {/*  </Col>*/}
          {/*</Row>*/}
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'middle'} justify={'center'}>
            <FormItem>
              <NavLink to={COMMON_ROUTER + '/goods'}><Button className="login-form-button" style={{marginRight: 30}}>返回</Button></NavLink>
            </FormItem>
            <FormItem>
              <Button type="primary" loading={loading} htmlType="submit" className="login-form-button">确认</Button>
            </FormItem>
          </Row>
        </Form>
      </Card>
    );
  }
}

const EditGoods = withRouter(EditGood)
export default EditGoods




// WEBPACK FOOTER //
// ./src/pages/goods/edit-goods/index.js